import includes from './includes';

/* type-safe way of filtering an array to an array of type-valid values */
export default function filterIncludes(values, validValues) {
  return values.filter(value => includes(validValues, value));
}